import { useEffect, useState } from "react";

export default function ProfilePage() {
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState('');
  const [msgStatus, setMsgStatus] = useState('');
  const [error, setError] = useState('');
  const [topics, setTopics] = useState([]);
  const [topicId, setTopicId] = useState('');

  useEffect(() => {
    async function fetchMe() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/users/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error('Kunne ikke hente bruker');
        setUser(await res.json());
      } catch (err) {
        setError('Kunne ikke hente brukerdata');
      }
    }
    fetchMe();
  }, []);

  useEffect(() => {
    async function fetchTopics() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/message-topics`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error('Kunne ikke hente kategorier');
        setTopics(await res.json());
      } catch {
        setTopics([]);
      }
    }
    fetchTopics();
  }, []);

  async function handleSendMessage(e) {
    e.preventDefault();
    setMsgStatus('');
    if (!message.trim() || !topicId) return setMsgStatus("Velg kategori og skriv melding.");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/inbox`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ MessageTopicId: topicId, message })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Feil ved innsending');
      setMsgStatus('Forespørsel sendt!');
      setMessage('');
      setTopicId('');
    } catch (err) {
      setMsgStatus('Feil: ' + err.message);
    }
  }

  if (error) return <div className="text-red-500 mt-8 text-center">{error}</div>;
  if (!user) return <div className="text-center mt-8">Laster profil...</div>;

  const postalCity = [user.postal_code, user.city].filter(Boolean).join(' ');

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl shadow mt-10">
      <h2 className="text-2xl font-semibold text-[#000099] mb-3">Min profil</h2>
      <div className="mb-6 space-y-1">
        <div><strong>Navn:</strong> {user.name}</div>
        <div><strong>E-post:</strong> {user.email}</div>
        <div><strong>Telefon:</strong> {user.phone || "–"}</div>
        <div><strong>Adresse:</strong> {user.address || "–"}</div>
        <div><strong>Postnr/Sted:</strong> {postalCity || "–"}</div>
        <div><strong>Kundetype:</strong> {user.isBusiness ? `Bedrift (${user.orgNumber})` : "Privat"}</div>
      </div>

      <h3 className="text-lg font-semibold mt-6 mb-2">Ordrer</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-[#12387a]">
          <thead>
            <tr>
              <th className="text-left px-4 py-2">Ordre-ID</th>
              <th className="text-left px-4 py-2">Dato</th>
              <th className="text-left px-4 py-2">Status</th>
              <th className="text-left px-4 py-2">Sum</th>
              <th className="text-left px-4 py-2">Betaling</th>
            </tr>
          </thead>
          <tbody>
            {(user.Orders?.length ? user.Orders : []).map(order => (
              <tr key={order.id} className="border-t">
                <td className="text-left px-4 py-2">{order.id}</td>
                <td className="text-left px-4 py-2">{new Date(order.createdAt).toLocaleDateString("no-NO")}</td>
                <td className="text-left px-4 py-2">{order.Status?.name || order.status || '–'}</td>
                <td className="text-left px-4 py-2">{order.total?.toLocaleString('no-NO')} kr</td>
                <td className="text-left px-4 py-2">{order.PaymentOption?.name || '–'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {(!user.Orders || user.Orders.length === 0) && <div className="text-gray-500">Ingen ordrer funnet.</div>}
      </div>

      <h3 className="text-lg font-semibold mt-8 mb-2">Be om endring eller kontakt admin</h3>
      <form onSubmit={handleSendMessage} className="flex flex-col gap-3">
        <select
          className="border rounded p-2 w-full"
          value={topicId}
          onChange={e => setTopicId(e.target.value)}
          required
        >
          <option value="">Velg kategori...</option>
          {topics.map(t => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>
        <textarea
          className="border rounded p-2 w-full min-h-[80px]"
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Skriv din forespørsel eller melding her..."
        />
        <button className="self-end bg-[#000099] text-white px-6 py-2 rounded hover:bg-blue-900" type="submit">
          Send forespørsel
        </button>
        {msgStatus && <div className={`mt-1 text-sm ${msgStatus.startsWith('Feil') ? 'text-red-500' : 'text-green-600'}`}>{msgStatus}</div>}
      </form>
    </div>
  );
}
